import { render } from "./HadKidsInTheUKPage.vue?vue&type=template&id=1c5e8d19"
import script from "./HadKidsInTheUKPage.vue?vue&type=script&lang=js"
export * from "./HadKidsInTheUKPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__